/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect, useRef } from "react";
import { Loader } from "@progress/kendo-react-indicators";
import { PDFExport } from "@progress/kendo-react-pdf";
import lynxLogo from "assets/images/logo.png";
import VaultDailyReportNew from "./vaultReportGrid";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  CardDescription,
  Combobox,
  DatePicker,
} from "@repo/ui";
import {
  useGetCashCenters,
  useGetCurrenciesList,
  useGetCustomers,
} from "utils/apis/lookups.api";
import { useGetVaultDailyReports } from "utils/apis/reports.api";
import { getCustomerLogo, isOperationAllowed, showToast } from "utils/helper";
import Layout from "components/layout";
import { Link } from "react-router-dom";
import { formatDate } from "date-fns";
import { Permissions } from "utils/enums";

const currentDate = new Date();

function VaultDailyReport() {
  const [operationDate, setOperationDate] = useState(currentDate);

  const [fitCashSummary, setFitCashSummary] = useState<Record<
    string,
    any
  > | null>(null);
  const [otherCashSummary, setOtherCashSummary] = useState(null);

  const [ddlCashCenters, setDdlCashCenters] = useState("");
  const [cashCenter, setCashCenter] = useState("--");
  const [ddlCustomers, setDdlCustomers] = useState("");
  const [customer, setCustomer] = useState("--");
  const [ddlCurrencies, setDdlCurrencies] = useState("");
  const [currency, setCurrency] = useState("--");

  const [reportDate, setReportDate] = useState("--");
  const [reportName, setReportName] = useState("");

  const [loaderPanel, setLoaderPanel] = useState("d-none");
  const [disableDdlCc, setDisableDdlCc] = useState(false);
  const [disableDdlCustomers, setDisableDdlCustomers] = useState(false);
  const [disableDdlCurrencies, setDisableDdlCurrencies] = useState(false);
  const [disableTxtOpsDate, setDisableTxtOpsDate] = useState(false);

  const { data: cashCenters } = useGetCashCenters();
  const { data: customers } = useGetCustomers();
  const { data: currencies } = useGetCurrenciesList();

  const pdfExportComponent = useRef<any>(null);

  useEffect(() => {
    const rptDate = `${(operationDate || currentDate).getDate()}/${
      (operationDate || currentDate).getMonth() + 1
    }/${(operationDate || currentDate).getFullYear()}`;

    setReportDate(rptDate);
  }, [operationDate]);

  function enableControls() {
    setDisableDdlCc(false);
    setDisableDdlCustomers(false);
    setDisableDdlCurrencies(false);
    setDisableTxtOpsDate(false);
    setLoaderPanel("d-none");
  }

  const {
    data: vaultDailyData,
    mutate: getVaultReport,
    error,
    isPending,
  } = useGetVaultDailyReports();

  useEffect(() => {
    if (vaultDailyData) {
      const { fitCashSummary, unFitCashSummary } = vaultDailyData;

      setFitCashSummary({ ...fitCashSummary });

      setOtherCashSummary(unFitCashSummary);

      enableControls();
    }
    if (error) {
      setFitCashSummary(null);
      setOtherCashSummary(null);
      showToast("error", "No data Found.");
      enableControls();
    }
  }, [vaultDailyData, error]);

  const onDdlCashCentersChanged = (value: string) => {
    setDdlCashCenters(value);
    if (!value) {
      setCashCenter("--");
      setDdlCashCenters("");
    } else {
      const findCashCenter = cashCenters?.find(
        (curr: any) => curr?.cashCenterId === value
      );
      setCashCenter(findCashCenter.name);
    }
  };

  const onDdlCustomersChanged = (value: string) => {
    setDdlCustomers(value);
    if (!value) {
      setCustomer("--");
      setDdlCustomers("");
    } else {
      const findCustomer = customers?.find(
        (curr: any) => curr?.customerId === value
      );
      setCustomer(findCustomer?.name);
    }
  };

  const onDdlCurrenciesChanged = (value: string) => {
    setDdlCurrencies(value);
    if (!value) {
      setDdlCurrencies("");
      setCurrency("--");
    } else {
      const findCurrency = currencies?.find(
        (curr: any) => curr?.shortName === value
      );
      setCurrency(findCurrency?.name);
    }
  };

  const onBtnGenerateReportClicked = () => {
    if (!ddlCashCenters) {
      showToast("error", "Please select cash center.");
      return;
    }

    if (!ddlCustomers) {
      showToast("error", "Please select customer.");
      return;
    }

    if (!ddlCurrencies || ddlCurrencies === "0") {
      showToast("error", "Please select currency.");
      return;
    }

    const cashCenterId = ddlCashCenters;
    const customerId = ddlCustomers;
    const customerName = customer;
    const selCurrency = ddlCurrencies;

    const reportParams = {
      customerId,
      cashCenterId,
      currency: selCurrency,
      operationDate: formatDate(
        operationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'"
      ),
    };

    getVaultReport(reportParams);

    setReportName(
      `${customerName}_Vault_Daily_Report_${(operationDate || currentDate).getDate()}_${
        (operationDate || currentDate).getMonth() + 1
      }_${(operationDate || currentDate).getFullYear()}`
    );
  };

  const exportToPDF = () => {
    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }
  };

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Reports</BreadcrumbPage>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Vault Daily Report</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <Card className="mt-3 mx-4">
        <CardContent>
          <CardDescription className="pt-6">
            <div className="flex gap-3">
              <div className="flex-1">
                <Combobox
                  disabled={disableDdlCc}
                  placeholder="Select Cash center"
                  value={ddlCashCenters}
                  data={cashCenters?.map((item) => ({
                    value: item.cashCenterId,
                    label: item.name,
                  }))}
                  setValue={onDdlCashCentersChanged}
                />
              </div>

              <div className="flex-1">
                <Combobox
                  disabled={disableDdlCustomers}
                  placeholder="Select Customer"
                  value={ddlCustomers}
                  data={customers?.map((item) => ({
                    value: item.customerId,
                    label: item.name,
                  }))}
                  setValue={onDdlCustomersChanged}
                />
              </div>

              <div className="flex-1">
                <Combobox
                  disabled={disableDdlCurrencies}
                  placeholder="Select Currency"
                  value={ddlCurrencies}
                  data={currencies?.map((item: any) => ({
                    value: item?.shortName,
                    label: item?.name,
                  }))}
                  setValue={onDdlCurrenciesChanged}
                />
              </div>

              <div className="flex-1">
                <DatePicker
                  disabled={disableTxtOpsDate}
                  placeholder="Select Operations Date"
                  selectedDate={operationDate}
                  onSelectDate={setOperationDate}
                />
              </div>

              <div className="flex gap-3">
                <Button
                  variant="secondary"
                  onClick={onBtnGenerateReportClicked}
                  isLoading={isPending}
                >
                  Get Report
                </Button>

                {isOperationAllowed(
                  Permissions.Report,
                  Permissions.PdfExport
                ) ? (
                  <Button variant="secondary" onClick={exportToPDF}>
                    <svg
                      viewBox="0 0 512 512"
                      fill="currentColor"
                      className="w-6"
                    >
                      <path d="M240.9 160c-7.6 0-13.8 4-15.4 9.9-4.9 18.6.2 46.3 9.4 82.3l-2.4 5.9c-6.6 16.4-14.8 33-22.1 47.6l-1 1.9c-7.7 15.3-14.6 28.4-21 39.4l-6.5 3.5c-.5.3-11.6 6.3-14.3 7.9-22.2 13.6-36.9 28.9-39.4 41.2-.8 3.9-.2 8.9 3.7 11.2l6.3 3.2c2.7 1.4 5.6 2.1 8.6 2.1 15.8 0 34.2-20.2 59.5-65.3 29.2-9.7 62.5-17.8 91.6-22.3 22.2 12.8 49.5 21.7 66.8 21.7q4.65 0 7.8-.9c3.3-.9 6.1-2.8 7.8-5.4 3.4-5.2 4-12.2 3.1-19.5-.3-2.1-2-4.8-3.8-6.6-5.1-5.2-16.5-7.9-33.7-8.1-11.7-.1-25.8.9-40.6 3-6.6-3.9-13.5-8.2-18.8-13.3-14.4-13.8-26.5-32.9-34-53.9.5-2 .9-3.7 1.3-5.4 0 0 8.1-47.1 6-63.1-.3-2.2-.5-2.8-1.1-4.5l-.7-1.9c-2.2-5.2-6.5-10.7-13.3-10.4zm2.7 8.4c5.1 0 8 13.1 8.2 25.4.3 12.3-2.6 20.9-6 27.3-2.9-9.4-4.3-24.3-4.3-34-.1-.1-.3-18.7 2.1-18.7m.4 104.1c8.6 16 19.3 29.5 31.9 40.4 1.6 1.3 3.2 2.7 5 4.1-25.6 5.2-47.7 11.5-67.1 19.1 3.6-6.5 7.2-13.3 11-20.6 9.1-17.7 14.9-31.6 19.2-43m102.2 51.6c9.3 0 12 0 21.1 2.3 9.1 2.4 9.2 7.2 7.6 8.2s-6 1.6-8.9 1.6c-9.2 0-20.7-4.3-36.8-11.4 6.3-.4 11.9-.7 17-.7m-165.4 35.8c-17.7 28.8-29.5 40.3-37.3 43.8 2.9-8.1 14.3-24 31.2-38.1 1.1-.9 3.7-3.4 6.1-5.7M352 32H96c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V128zm64 416H96V64h224v96h96z" />
                    </svg>
                  </Button>
                ) : null}
                {/* <Button variant="secondary" onClick={exportToExcel}>
                  <svg
                    viewBox="0 0 512 512"
                    fill="currentColor"
                    className="w-6"
                  >
                    <path d="m288 304 64 112h-48l-48-84.5-31.5 52.5H256v32h-96l64-112-64-112h48l48 84 48-84h48zm64-272H96c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V128zm64 416H96V64h224v96h96z" />
                  </svg>
                </Button> */}
              </div>
            </div>
            <div className="border-b my-3 bg-accent" />
            <div className={`text-center ${loaderPanel}`}>
              <Loader size="large" type="converging-spinner" />
            </div>
            <PDFExport
              scale={0.3}
              ref={pdfExportComponent}
              paperSize="A4"
              fileName={reportName}
              margin={{ top: 10, bottom: 10, right: 14, left: 14 }}
            >
              <div className="flex gap-5 items-center pt-6">
                <div className="max-w-48 w-full text-end">
                  <img src={lynxLogo} className="w-full" alt="logo" />
                </div>

                <div className="flex-[3]">
                  <span className="text-primary-darken-3 h6">{`Cash Center: ${cashCenter}`}</span>
                  <div className="border-bottom mt-2 mb-2 bg-accent-4" />
                  <span className="text-primary-darken-3 h6">{`Bank Name: ${customer}`}</span>
                  <div className="border-bottom mt-2 mb-2 bg-accent-4" />
                  <span className="text-primary-darken-3 h6">{`Currency: ${currency}`}</span>
                  <div className="border-bottom mt-2 mb-2 bg-accent-4" />
                  <span className="text-primary-darken-3 h6">{`Report Date: ${reportDate}`}</span>
                  <div className="border-bottom mt-2 mb-2 bg-accent-4" />
                </div>

                <div className="flex-[3] text-center">
                  <h5>
                    <u>Vault Daily Report</u>
                  </h5>
                </div>

                <div className="flex-1 text-start">
                  <img
                    src={getCustomerLogo()}
                    style={{ height: "80px" }}
                    alt="logo"
                  />
                </div>
              </div>
              {fitCashSummary ? (
                <VaultDailyReportNew
                  fitCashSummary={fitCashSummary}
                  otherCashSummary={otherCashSummary}
                />
              ) : null}
            </PDFExport>
          </CardDescription>
        </CardContent>
      </Card>
    </Layout>
  );
}

export default VaultDailyReport;
